import React, {useState, useEffect} from 'react';
import CartInputField from './CartInputField';

function CartPayments(props) {
  const paymentArray = [
    {
      id: "1",
      name: "Carta di Credito",
      descr: "Pagamento con Carta di Credito",
      imgUrl: "/images/Carte_credito_cart.svg",
      imgAlt: "Carte di credito accettate",
      css: "pagamento_01_cart",
      requiredShipment: [], 
    },
    {
      id: "2",
      name: "PayPal",
      descr: "Pagamento con conto PayPal o carta di credito su circuito PayPal",
      imgUrl: "/images/PayPal_cart.svg",
      imgAlt: "PayPal",
      css: "pagamento_02_cart",
      requiredShipment: [],
    },
    {
      id: "3",
      name: "Bonifico Bancario Anticipato",
      descr: "Con BONIFICO BANCARIO anticipato intestato a: MEDIATOYS srl IBAN IT04X0327302400000600102568 (per bonifici dall'estero - BIC: CRDRIT2FXXX) Via Marsala 15, 40136 BOLOGNA Solution Bank Spa. In questo caso è importantissimo che nella causale del bonifico venga riportato il numero d'ordine",
      imgUrl: "",
      imgAlt: "",
      css: "pagamento_03_cart",
      requiredShipment: [],
    },
    {
      id: "4",
      name: "Contanti alla consegna",
      descr: "la merce sarà pagata al corriere in contanti (contrassegno)",
      imgUrl: "",
      imgAlt: "",
      css: "pagamento_03_cart",
      requiredShipment: [],
    },
    {
      id: "5",
      name: "Ricarica La Nostra PostePay",
      descr: "(Pagamento eseguibile on-line o direttamente all'uficio postale. Non è richiesta nessuna scheda) - Carta numero: 4023 6009 5595 7198 - Intestata a : Zabban Guido In questo caso è necessaria una email o una telefonata per permettere di incrociare i dati del pagamento",
      imgUrl: "",
      imgAlt: "",
      css: "pagamento_03_cart",
      requiredShipment: [],
    },
    {
      id: "6",
      name: "Ritiro E Pagamento In Sede",
      descr: "Ritiro del pacco con Pagamento in contanti o con carta di credito presso la sede di Bologna",
      imgUrl: "",
      imgAlt: "",
      css: "pagamento_03_cart",
      requiredShipment: ["2"],
    },
  ];
  const [ErrorMsg, setErrorMsg] = useState(() => {
    const initialState = initErrorMsg();
    return initialState;
  });

  function initErrorMsg() {
    //console.log(props.name);
    if (!props.errList || props.errList.length === 0)
      return "";
    let txt = "";
    let errList = props.errList.filter((el) => el.id === "Payment");
    if (errList.length > 0) {
      errList.forEach((el) => txt += el.msg+ " ");
    }   
    const initialState = txt;
    return initialState;
  };

  useEffect(() => {
    //if (ErrorMsg === "") {
      setErrorMsg(initErrorMsg());
    //}
  }, [props.errList]);

  function changeHandler(val) {
    setErrorMsg("");
    props.change(val);
  }

  function showError() {
    if (!props.errList || props.errList.length === 0)
      return null;
    let errList = props.errList.filter((el) => el.id === "Payment");
    if (errList.length > 0) {
      return (
        <div className="campo_vuoto_cart">
          {errList.map((el, i) => (
            <p key={"er_"+i}>{el.msg}</p>
          ))}
        </div>
      )
    }
  } 

  //console.log(props);
  return (
    <div className="pagamenti_cart">
      <div className="titolo_pagamenti_cart">
        <h2>{props.title}</h2>
      </div>

      <div className="elenco_pagamenti_cart">
        {paymentArray.map((el) => {
          if (
            !props.shipmentId ||
            props.shipmentId === "" ||
            el.requiredShipment.length === 0 ||
            el.requiredShipment.indexOf(props.shipmentId) >= 0
          ) {
            return (
              <CartInputField
                key={el.id}
                required={false}
                type="radio"
                lbl={el.name}
                name="Payment"
                value={el.id}
                change={changeHandler}
                cssClass={el.css}
                labelRight={true}
                curVal={props.value}
                imgUrl={el.imgUrl}
                imgAlt={el.imgAlt}
              />
            );
          } else return null;
        })}
        {ErrorMsg.length > 0 ? (
          <div className="errore_cart">
            <p>{ErrorMsg}</p>
          </div>
        ) : null}
        <div className="clear"></div>
      </div>
    </div>
  );
}

export default CartPayments;